import script from "./ProfileResearchPublicationItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileResearchPublicationItem.vue?vue&type=script&setup=true&lang=js"

import "./ProfileResearchPublicationItem.vue?vue&type=style&index=0&id=352263d9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-352263d9"]])

export default __exports__